import React, { Component } from 'react';
import './App.css';
import {BrowserRouter as Router, Switch, Route, useHistory} from 'react-router-dom';
import Home from './pages/Home';
import Faq from './pages/Faq';
import Entrylevel from './pages/Entrylevel';
import Laterals from './pages/Laterals';
import Specialization from './pages/Specialization';
import Upcoming from './pages/Upcoming';
import Rolebased from './pages/Rolebased';
import Footer from './function-components/Footer';
import Searchnav from './function-components/Searchnav';
// import SSOLogin from './SSOLogin';
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from './function-components/PageLayout';
function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);
  
  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
        <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {

  const basename =
    window.location.hostname === "stagingapps1.lttlx.accenture.com"
      ? "/securitylearnings"
      : "/";
  return (
    <>
      <Router basename = {basename}>
        <Searchnav />
        {/* <Navbarmenu /> */}
        <Switch>
          <Route exact path="/home">
            <Home />
            </Route>
          <Route exact path="/faq">
            <Faq />
            </Route>
          <Route exact path="/security-entry-level">
            <Entrylevel />
            </Route>
          <Route exact path="/security-laterals">
            <Laterals />
            </Route>
          <Route path="/security-specialization">
            <Specialization />
            </Route>
            <Route exact path="/upcoming-events">
            <Upcoming />
            </Route>
            <Route exact path="/role-based">
            <Rolebased />
            </Route>
            <Route exact path="/">
            <Home />
            </Route>
        </Switch>
        <Footer />
      </Router>
     
    </>
  );
}

export default App;
